import { AppointmentFormBody } from "@/components/calendar/AppointmentForm";
import type { AppointmentDetailsController } from "@/components/calendar/useAppointmentDetailsController";

export function MobileAppointmentEditView({ ctrl }: { ctrl: AppointmentDetailsController }) {
  const { appointment, handleCloseEdit, onOpenChange } = ctrl;
  if (!appointment) return null;
  return (
    <main className="flex min-h-0 flex-1 flex-col bg-background-app">
      <AppointmentFormBody
        mode="edit"
        clinicId={appointment.clinic_id}
        appointmentId={appointment.id}
        initialAppointment={appointment}
        onClose={handleCloseEdit}
        onSuccess={handleCloseEdit}
        onDeleteSuccess={() => {
          handleCloseEdit();
          onOpenChange(false);
        }}
        mobileLayout
      />
    </main>
  );
}
